export default "__VITE_ASSET__taNpC6E3__"